/* eslint-disable lines-around-comment */
import { newsConstants } from "./constants"
import actions from "../../actions"

const initialState = {
	news          : [],
	oneNews       : null,
	isFileSending : false,
	newsFile      : null,
	isSending     : false,
	changed       : null
}

export default function (state = initialState, action){
	switch (action.type){
		case newsConstants.changeNews.REQUEST:
		case newsConstants.deleteNews.REQUEST:
		case newsConstants.createNews.REQUEST:
		case newsConstants.getOneNews.REQUEST:
		case newsConstants.getAllNews.REQUEST:
		case newsConstants.restoreNews.REQUEST:
		case newsConstants.getNews.REQUEST:
			return {
				...state,
				isSending : true,
				changed   : null
			}
		case newsConstants.changeNews.FAILURE:
		case newsConstants.deleteNews.FAILURE:
		case newsConstants.getOneNews.FAILURE:
		case newsConstants.createNews.FAILURE:
		case newsConstants.restoreNews.FAILURE:
		case newsConstants.getNews.FAILURE:
		case newsConstants.getAllNews.FAILURE:
			return {
				...state,
				isSending : false,
				error     : action.payload,
				changed   : null
			}
		case newsConstants.deleteNews.SUCCESS:
			return {
				...state,
				isSending : false,
				changed   : action.payload.result ? actions.delete : null
			}
		case newsConstants.changeNews.SUCCESS:
			return {
				...state,
				isSending : false,
				changed   : action.payload.result ? actions.update : null
			}
		case newsConstants.createNews.SUCCESS:
			return {
				...state,
				changed: action.payload.result ? actions.create : null
			}
		case newsConstants.getOneNews.SUCCESS:
			return {
				...state,
				isSending : false,
				oneNews   : action.payload.result
			}
		case newsConstants.getAllNews.SUCCESS:
		case newsConstants.getNews.SUCCESS:
			return {
				...state,
				isSending : false,
				news      : action.payload.result
			}
		case newsConstants.downloadFile.REQUEST:
			return {
				...state,
				isFileSending: true
			}
		case newsConstants.downloadFile.SUCCESS:
			return {
				...state,
				isFileSending : false,
				newsFile      : action.payload.result
			}
		case newsConstants.downloadFile.FAILURE:
			return {
				...state,
				isFileSending : false,
				error         : action.payload.err.data
			}
		case newsConstants.restoreNews.SUCCESS:
			return {
				...state,
				isSending : false,
				changed   : action.payload.result ? actions.restore : null
			}
		case newsConstants.clear:
			return {
				...state,
				...initialState
			}
		default:
			return state
	}
}